<template>
  <AdminSectionContainer>
    <div class="d-flex justify-start">
      <h2 class="pr-3">
        Gestion des organisations
      </h2>
      <ClosableDialog icon="add_circle" ref="newOrgDialog">
        <OrganizationForm @saved="organizationChanged" />
      </ClosableDialog>
    </div>

    <div class="d-flex pr-2 mr-1">
      <v-select
        class="pr-5"
        v-model="selectedOrganization"
        :items="organizations"
        label="Organisation"
        @change="change()"
      >
        <template v-slot:item="item">
          <div>
            <span>{{ item.item.name }}</span>
            <span class="ml-2 smaller-text">
              {{ item.item.id }}
            </span>
          </div>
        </template>
        <template v-slot:selection="selection">
          <div>
            <span>{{ selection.item.name }}</span>
            <span class="ml-2 smaller-text">
              {{ selection.item.id }}
            </span>
          </div>
        </template>
      </v-select>
      <ClosableDialog
        v-if="organization.id"
        icon="settings"
        ref="updateOrgDialog"
      >
        <OrganizationForm
          :organization="organization"
          @saved="organizationChanged"
        />
      </ClosableDialog>
    </div>
    <UserManagement
      v-if="selectedOrganization"
      :organization="organization"
      :loading="loading"
      class="mt-3"
      @saved="change()"
    />
    <GroupManagement
      v-if="selectedOrganization"
      :organization="organization"
      :loading="loading"
      class="mt-6"
      @saved="change()"
    />
  </AdminSectionContainer>
</template>
<script>
import ClosableDialog from '@/shared/components/dialog/ClosableDialog';
import AdminSectionContainer from './AdminSectionContainer';
import { OrganizationService } from './OrganizationService';
import UserManagement from './UserManagement';
import GroupManagement from './GroupManagement';
import OrganizationForm from './OrganizationForm';

export default {
  name: 'OrganizationManagement',
  components: {
    AdminSectionContainer,
    UserManagement,
    GroupManagement,
    ClosableDialog,
    OrganizationForm,
  },
  data() {
    return {
      selectedOrganization: undefined,
      organization: {},
      organizations: [],
    };
  },
  computed: {
    loading() {
      return this.organization.id === undefined;
    },
  },
  async created() {
    await this.updateOrganizations();
  },
  methods: {
    async updateOrganizations() {
      const organizationService = new OrganizationService();
      this.organizations = await organizationService.fetchOrganizations();
    },
    async change() {
      this.organization = {};

      const organizationService = new OrganizationService();
      const users = await organizationService.fetchUsersInOrganization(this.selectedOrganization.id);
      const groups = await organizationService.fetchGroupsInOrganization(this.selectedOrganization.id);

      users.sort((a, b) => a.firstName.localeCompare(b.firstName));
      groups.sort((a, b) => a.name.localeCompare(b.name));

      this.organization = {
        id: this.selectedOrganization.id,
        name: this.selectedOrganization.name,
        users,
        groups,
        maxUsers: this.selectedOrganization.maxUsers,
        maxGroups: this.selectedOrganization.maxGroups,
      };
    },
    async organizationChanged() {
      if (this.$refs.newOrgDialog) {
        this.$refs.newOrgDialog.close();
      }
      if (this.$refs.updateOrgDialog) {
        this.$refs.updateOrgDialog.close();
      }

      this.selectedOrganization = undefined;
      this.organization = {};
      await this.updateOrganizations();
    },
  },
};
</script>
<style>
.smaller-text {
  font-size: 12px;
  font-weight: 300;
}
</style>
